<template>
  <!--
    Progress bar for the streaming search.
    Fills as suppliers report (done or error), shows current hotel count while
    running and final total when everything's back. Stays visible after the
    search completes so the summary sits on-page.
  -->
  <div class="search-progress" v-if="hasSuppliers">
    <div class="search-progress__track">
      <div class="search-progress__fill" :style="{ width: percent + '%' }"></div>
    </div>
    <div class="search-progress__meta">
      <span v-if="!allDone" class="search-progress__phase">
        {{ doneCount }}/{{ totalCount }} ספקים · {{ hotelsSoFar }} מלונות נמצאו
      </span>
      <span v-else class="search-progress__phase search-progress__phase--done">
        סה"כ נמצאו {{ hotelsSoFar }} מלונות מ־{{ totalCount }} ספקים
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SearchProgressBar',
  computed: {
    ...mapGetters({
      supplierStatus: 'GET_SUPPLIER_STATUS',
      supplierCounts: 'GET_SUPPLIER_COUNTS',
    }),
    entries() {
      return Object.entries(this.supplierStatus || {});
    },
    hasSuppliers() {
      return this.entries.length > 0;
    },
    totalCount() {
      return this.entries.length;
    },
    doneCount() {
      return this.entries.filter(([, s]) => s === 'done' || s === 'error').length;
    },
    allDone() {
      return this.totalCount > 0 && this.doneCount === this.totalCount;
    },
    percent() {
      if (this.totalCount === 0) return 0;
      return Math.round((this.doneCount / this.totalCount) * 100);
    },
    hotelsSoFar() {
      return Object.values(this.supplierCounts || {}).reduce((a, b) => a + (Number(b) || 0), 0);
    },
  },
};
</script>

<style scoped>
.search-progress {
  margin: 12px 0 4px;
}
.search-progress__track {
  height: 8px;
  background: #eef1f6;
  border-radius: 999px;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
}
.search-progress__fill {
  height: 100%;
  background: linear-gradient(90deg, #1f4c96 0%, #4d7fd0 100%);
  transition: width 0.4s ease;
  border-radius: 999px;
}
.search-progress__meta {
  margin-top: 6px;
  text-align: center;
  font-size: 13px;
  color: #6b7d95;
}
.search-progress__phase--done {
  color: #1e6b3a;
  font-weight: 700;
}
</style>
